import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Toast } from 'ngx-toastr';

@Component({
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0 })),
      state('active', style({ opacity: 1 })),
      state('removed', style({ opacity: 0 })),
      transition('inactive => active', animate('300ms ease-out')),
      transition('active => removed', animate('300ms ease-in')),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  selector: 'orion-platform-dashboard-toast',
  standalone: true,
  styleUrls: ['./dashboard-notifier.component.scss'], // We can reuse the same SCSS for now
  templateUrl: './dashboard-toast.component.html',
})
export class DashboardToastComponent extends Toast {
  override remove(): void {
    super.remove();
  }
}
